import { h } from "preact";
import i18n from "../i18n.js";

import EmptyState from "./EmptyState.jsx";
import TaskListHeader from "./TaskListHeader.jsx";
import TaskListItem from "./TaskListItem.jsx";

export default function TaskList({ noLink, user, tasks }) {
  return (
    <div class="task_list mt-24">
      <TaskListHeader />
      {tasks.length === 0 ? (
        <EmptyState
          icon="tasks_empty"
          title={i18n.t("component.task_list.title")}
          description={i18n.t("component.task_list.description")}
        />
      ) : (
        <div class="task_list__items" role="list">
          {tasks.map((task) => (
            <TaskListItem task={task} noLink={noLink} user={user} />
          ))}
        </div>
      )}
    </div>
  );
}
